import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'emptyValue',
})
export class EmptyValuePipe implements PipeTransform {
	public transform<T>(value: T): T | string {
		// @ts-ignore
		if (value !== 0 && value !== false && !value) {
			return '-';
		}

		return value;
	}
}
